import React from 'react';

export const PlayIcon = () => (
  <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 42 34" fill="none">
    <rect x="0.5" y="0.5" width="41" height="33" rx="3.5" fill="white" />
    <path d="M16 25L29 17L16 9L16 25Z" fill="currentColor" />
  </svg>
);
